// Types
import { State, LicenseVersionWithLicenseTypes, LicenseRevenue } from 'types'

export const selectRevenueInfo = (state: State, category: number, type: number): LicenseRevenue | null | undefined => {
  if (!category || !type) {
    return null
  }
  const { licenseRevenues } = state.entities
  const licenseRevenuesList = Object.keys(licenseRevenues).map(id => licenseRevenues[id])
  return licenseRevenuesList.find(r => r.category === category && r.sample_type === type)
}

export const selectLatestLicenseVersion = (state: State): LicenseVersionWithLicenseTypes => {
  const { licenseTypes, licenseVersions } = state.entities
  const licenseVersionsList = Object.keys(licenseVersions).map(id => licenseVersions[id])
  const latestLicenseVersion = licenseVersionsList.sort((a, b) => b.version - a.version)[0]

  return {
    ...latestLicenseVersion,
    sample_types: latestLicenseVersion.sample_types.map(id => licenseTypes[String(id)]),
  }
}
